/* BUNDLE PERSONALISATION 29-10-2026
   Adds a per-item "Personalise" panel to every product card in a Selleasy bundle
   (lb-upsell-widget). Each product's embossing options and price come from its own
   Hulk option set; the character limit comes from the custom.personalisation_char_limit
   metafield (default 7). When the bundle is added, the Hulk line properties are attached
   to that item, so Hulk charges the embossing and the bundle discount applies to it. */
(function () {
  "use strict";

  var SYMBOLS = ["!", "*", "()", "#", "-", "_", "=", "+", '"', ",", "/", ".", "♥"];
  var TEXT_CLASS = "artisans-custom-embossing-charge";
  var TYPE_CLASS = "embossing-card-type";

  var productData = {}; // product id -> Promise<{ text, type, limit } | null>
  var state = {}; // offer|product id -> { open, text, type }

  function hulk() {
    return window.hulkapps || null;
  }

  function money(amount) {
    var symbol = (hulk() && hulk().currency_symbol) || "£";
    return symbol + Number(amount).toFixed(2);
  }

  // Hulk's old swatch host refuses its images; the same files live in the store's Files.
  function swatchImage(url) {
    if (!url) return "";
    var name = url.split("/").pop().split("?")[0].replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(\.\w+)$/i, "$1");
    return "https://cdn.shopify.com/s/files/1/0400/5589/8277/files/" + name + "?width=160";
  }

  function fetchHulkOptions(product) {
    var H = hulk();
    if (!H || !H.po_proxy_url) return Promise.resolve(null);
    var body = new URLSearchParams({
      hpage_type: "product_page",
      pid: product.id,
      store_id: H.store_id,
      tags: (product.tags || []).join(","),
      vendor: product.vendor || "",
      ptype: product.type || "",
      customer_tags: "",
      product_collections: "",
      shopify_currency_rate: window.hulkapps_shopify_rate || 1,
      product_variants: product.variants.map(function (v) { return v.id; }).join(","),
      buyer_country_code: (window.Shopify && window.Shopify.country) || "",
      currency_code: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ""
    });
    return fetch(H.po_proxy_url + "/get_all_relationships", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
      body: body
    }).then(function (r) { return r.json(); });
  }

  function loadProduct(id, handle) {
    if (productData[id]) return productData[id];
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    productData[id] = Promise.all([
      fetch(root + "products/" + handle + ".js").then(function (r) { return r.json(); }),
      fetch(root + "products/" + handle + "?view=bundle-personalisation").then(function (r) { return r.json(); }).catch(function () { return {}; })
    ]).then(function (res) {
      var product = res[0];
      var limit = parseInt(res[1].limit, 10) || 7;
      return fetchHulkOptions(product).then(function (h) {
        var options = (h && h.option_associative_array) || {};
        var text = null;
        var type = null;
        Object.keys(options).forEach(function (key) {
          var o = options[key];
          var values = [];
          try { values = JSON.parse(o.values_json || "[]"); } catch (e) {}
          var cls = (o.class_name || "").trim();
          if (!text && o.option_type === "textbox" && cls === TEXT_CLASS) {
            text = { name: o.option_name, price: parseFloat((values[0] || [])[1]) || 0 };
          } else if (!type && cls === TYPE_CLASS) {
            type = {
              name: o.option_name,
              values: values.map(function (v) { return { label: v[0], image: swatchImage(v[3]) }; })
            };
          }
        });
        if (!text || !type) return null;
        return { text: text, type: type, limit: limit };
      });
    }).catch(function () { return null; });
    return productData[id];
  }

  function keyFor(card) {
    var widget = card.closest("lb-upsell-widget");
    return (widget ? widget.getAttribute("offer") : "") + "|" + card.getAttribute("lb-product-id");
  }

  function discountPercent(card) {
    var el = card.querySelector(".lb-price-discount");
    var m = el && el.textContent.match(/(\d+(?:\.\d+)?)\s*%/);
    return m ? parseFloat(m[1]) : 0;
  }

  function isSelected(card) {
    var box = card.querySelector("input.lb-card-checkbox");
    return !box || box.checked || !!card.querySelector(".lb-custom-checkbox.lb-checked");
  }

  // Same per-colour embossing photos product.js uses (/cdn/shop/files/tan1.jpg ...)
  var COLOURS = ["black", "darkbrown", "natural", "red", "silver", "tan"];
  function leatherColour(card) {
    var select = card.querySelector("select.lb-variant-picker");
    var option = select && select.options[select.selectedIndex];
    var name = option ? option.text.toLowerCase().replace(/\s+/g, "") : "";
    return COLOURS.indexOf(name) !== -1 ? name : "";
  }

  function priceLabel(card, data) {
    var pct = discountPercent(card);
    var full = data.text.price;
    if (!pct) return "+" + money(full);
    return "+" + money(full * (1 - pct / 100)) + " (" + money(full) + " less " + pct + "%)";
  }

  function render(card, data) {
    var key = keyFor(card);
    var s = state[key] || (state[key] = { open: false, text: "", type: "" });
    var panel = card.nextElementSibling && card.nextElementSibling.classList.contains("bp-panel") ? card.nextElementSibling : null;
    if (!panel) {
      panel = document.createElement("div");
      panel.className = "bp-panel";
      card.parentNode.insertBefore(panel, card.nextSibling);
    }
    panel.setAttribute("data-key", key);
    panel.hidden = !isSelected(card);

    var colour = leatherColour(card);
    var types = data.type.values.map(function (v, i) {
      var image = colour ? "/cdn/shop/files/" + colour + (i + 1) + ".jpg?width=160" : v.image;
      return '<button type="button" class="bp-type' + (s.type === v.label ? " is-active" : "") + '" data-type="' + v.label.replace(/"/g, "&quot;") + '">' +
        (image ? '<img src="' + image + '" alt="" loading="lazy">' : "") +
        "<span>" + v.label + "</span></button>";
    }).join("");
    var symbols = SYMBOLS.map(function (c) {
      return '<button type="button" class="bp-symbol" data-symbol="' + c.replace(/"/g, "&quot;") + '">' + c + "</button>";
    }).join("");

    panel.innerHTML =
      '<button type="button" class="bp-toggle" aria-expanded="' + s.open + '">' +
        '<span class="bp-toggle-mark">' + (s.open ? "−" : "+") + "</span>" +
        "<span>Personalise this item</span>" +
        '<span class="bp-price">' + priceLabel(card, data) + "</span>" +
      "</button>" +
      '<div class="bp-body"' + (s.open ? "" : " hidden") + ">" +
        '<div class="bp-label">Select embossing</div>' +
        '<div class="bp-types">' + types + "</div>" +
        '<div class="bp-label">Enter text <span class="bp-limit">Character limit - ' + data.limit + " characters</span></div>" +
        '<input class="bp-input" type="text" maxlength="' + data.limit + '" autocomplete="off" value="' + s.text.replace(/"/g, "&quot;") + '">' +
        '<div class="bp-symbols">' + symbols + "</div>" +
        '<div class="bp-error" hidden></div>' +
      "</div>";

    panel.querySelector(".bp-toggle").onclick = function () {
      s.open = !s.open;
      render(card, data);
    };
    Array.prototype.forEach.call(panel.querySelectorAll(".bp-type"), function (b) {
      b.onclick = function () {
        s.type = b.getAttribute("data-type");
        render(card, data);
      };
    });
    var input = panel.querySelector(".bp-input");
    input.oninput = function () {
      s.text = input.value.slice(0, data.limit);
      panel.querySelector(".bp-error").hidden = true;
      updateTotal(card.closest("lb-upsell-widget"));
    };
    Array.prototype.forEach.call(panel.querySelectorAll(".bp-symbol"), function (b) {
      b.onclick = function () {
        var sym = b.getAttribute("data-symbol");
        if (s.text.length + sym.length > data.limit) return;
        s.text += sym;
        input.value = s.text;
        updateTotal(card.closest("lb-upsell-widget"));
      };
    });
    updateTotal(card.closest("lb-upsell-widget"));
  }

  function attach(card) {
    var id = card.getAttribute("lb-product-id");
    var handle = card.getAttribute("lb-product-handle");
    if (!id || !handle || !card.closest("lb-bundle")) return;
    loadProduct(id, handle).then(function (data) {
      if (data && card.isConnected) render(card, data);
    });
  }

  function cards(widget) {
    return Array.prototype.slice.call((widget || document).querySelectorAll("lb-bundle lb-upsell-flat-card[lb-product-id]"));
  }

  // personalisations the shopper finished, keyed by variant id
  function completed(widget, includeIncomplete) {
    var out = [];
    cards(widget).forEach(function (card) {
      var s = state[keyFor(card)];
      if (!s || !s.open || !isSelected(card)) return;
      var ok = s.text.trim() !== "" && s.type !== "";
      if (!ok && !includeIncomplete) return;
      out.push({ card: card, state: s, ok: ok });
    });
    return out;
  }

  function updateTotal(widget) {
    if (!widget) return;
    var cta = widget.querySelector("lb-bundle-cta");
    if (!cta) return;
    var note = widget.querySelector(".bp-total");
    var sum = 0;
    var pending = [];
    completed(widget).forEach(function (c) {
      pending.push(loadProduct(c.card.getAttribute("lb-product-id")).then(function (data) {
        if (data) sum += data.text.price * (1 - discountPercent(c.card) / 100);
      }));
    });
    Promise.all(pending).then(function () {
      if (!sum) {
        if (note) note.remove();
        return;
      }
      if (!note) {
        note = document.createElement("div");
        note.className = "bp-total";
        cta.parentNode.insertBefore(note, cta);
      }
      var text = "Includes personalisation: +" + money(sum);
      if (note.textContent !== text) note.textContent = text;
    });
  }

  function scan() {
    cards().forEach(function (card) {
      var next = card.nextElementSibling;
      if (!next || !next.classList.contains("bp-panel")) {
        attach(card);
      } else if (next.hidden !== !isSelected(card)) {
        next.hidden = !isSelected(card);
      }
    });
  }

  // Stop the bundle being added while a personalisation is half filled in.
  document.addEventListener("click", function (e) {
    var button = e.target.closest && e.target.closest("lb-bundle-cta lb-button");
    if (!button) return;
    var widget = button.closest("lb-upsell-widget");
    var bad = completed(widget, true).filter(function (c) { return !c.ok; });
    if (!bad.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    bad.forEach(function (c) {
      var panel = c.card.nextElementSibling;
      var err = panel && panel.querySelector(".bp-error");
      if (err) {
        err.textContent = c.state.type ? "Enter your text, or close personalisation." : "Choose an embossing type, or close personalisation.";
        err.hidden = false;
      }
    });
    var first = bad[0].card.nextElementSibling;
    if (first) first.scrollIntoView({ block: "center", behavior: "smooth" });
  }, true);

  // Attach the Hulk properties to the personalised items as Selleasy adds the bundle.
  var originalFetch = window.fetch;
  window.fetch = function (url, options) {
    try {
      if (String(url).indexOf("cart/add.js?src=selleasy") !== -1 && options && typeof options.body === "string") {
        var payload = JSON.parse(options.body);
        var done = completed(null);
        if (done.length && payload.items) {
          return Promise.all(done.map(function (c) {
            return loadProduct(c.card.getAttribute("lb-product-id")).then(function (data) {
              return { card: c.card, state: c.state, data: data };
            });
          })).then(function (list) {
            payload.items.forEach(function (item) {
              list.forEach(function (c) {
                if (!c.data) return;
                var variants = Array.prototype.map.call(c.card.querySelectorAll("select.lb-variant-picker option"), function (o) { return String(o.value); });
                variants.push(String(c.card.getAttribute("lb-variant-id")));
                if (variants.indexOf(String(item.id)) === -1 || item.properties && item.properties[c.data.text.name]) return;
                item.properties = item.properties || {};
                item.properties[c.data.text.name] = c.state.text.trim() + " [ " + money(c.data.text.price) + " ]";
                item.properties[c.data.type.name] = c.state.type;
              });
            });
            options = Object.assign({}, options, { body: JSON.stringify(payload) });
            return originalFetch.call(window, url, options);
          });
        }
      }
    } catch (e) {}
    return originalFetch.apply(this, arguments);
  };

  // Desktop (750px+, the theme's two-column breakpoint): the bundle stays under Add to Bag
  // and is laid out like an "Often bought together" block - the item photos in a row with
  // the total and button beside them, then one row per item. Mobile keeps Selleasy's layout.
  var desktop = window.matchMedia("(min-width: 750px)");

  function stripFor(widget) {
    var wrap = widget.querySelector(".lb-bundle-products-cont");
    if (!wrap) return;
    var strip = wrap.querySelector(":scope > .bp-strip");
    var list = cards(widget);
    var sig = list.map(function (card) {
      var img = card.querySelector("img.lb-card-img");
      return (img ? img.getAttribute("src") : "") + (isSelected(card) ? "" : "~");
    }).join("|");
    if (strip && strip.getAttribute("data-sig") === sig) return;
    if (!strip) {
      strip = document.createElement("div");
      strip.className = "bp-strip";
      strip.setAttribute("aria-hidden", "true");
      wrap.insertBefore(strip, wrap.firstChild);
    }
    strip.setAttribute("data-sig", sig);
    strip.innerHTML = list.map(function (card, i) {
      var img = card.querySelector("img.lb-card-img");
      return (i ? '<span class="bp-strip-plus">+</span>' : "") +
        '<span class="bp-strip-item' + (isSelected(card) ? "" : " is-off") + '">' +
        (img ? '<img src="' + img.getAttribute("src").replace(/"/g, "&quot;") + '" alt="">' : "") + "</span>";
    }).join("");
    var many = list.length > 2;
    if (widget.classList.contains("bp-ref-many") !== many) widget.classList.toggle("bp-ref-many", many);
  }

  function layout() {
    Array.prototype.forEach.call(document.querySelectorAll("lb-upsell-widget"), function (widget) {
      if (!widget.closest(".product-description-wrapper") || !widget.querySelector("lb-bundle")) return; // product page bundle only
      if (desktop.matches) {
        if (!widget.classList.contains("bp-ref")) widget.classList.add("bp-ref");
        stripFor(widget);
      } else if (widget.classList.contains("bp-ref")) {
        widget.classList.remove("bp-ref");
      }
    });
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      scan();
      layout();
      cards().forEach(function (c) { updateTotal(c.closest("lb-upsell-widget")); });
    });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ["class", "lb-variant-id"] });

  var resizeQueued = false;
  window.addEventListener("resize", function () {
    if (resizeQueued) return;
    resizeQueued = true;
    requestAnimationFrame(function () {
      resizeQueued = false;
      layout();
    });
  });

  document.addEventListener("change", function (e) {
    if (!e.target.closest || !e.target.closest("lb-upsell-widget")) return;
    var card = e.target.closest("lb-upsell-flat-card");
    if (card && e.target.matches("select.lb-variant-picker")) attach(card); // new colour, new swatch photos
    scan();
  });
  scan();
  layout();
})();
/* /BUNDLE PERSONALISATION */
